<template>
    <div>
        <div class="container order-content">
            <div class="manage-main">
                <div class="rule" style="overflow: hidden">
                    <Menu></Menu>
                    <div class="manage-right">
                        <div class="right-title">度假订单</div>
                        <div class="search-result">
                            <div class="search-result-head">
                                <p>搜索到<span class="price">{{total}}</span>条符合条件的订单</p>
                            </div>
                            <table class="result-table" id="table">
                                <thead>
                                <tr>
                                    <td style="width:180px;">订单号<br/>创建时间</td>
                                    <td style="width:220px;">产品名称<br/>产品类型</td>
                                    <td style="width:55px;">份数</td>
                                    <td style="width:100px;">出发日期<br/>有效期至</td>
                                    <td style="width:100px;">订单金额<br/>支付状态</td>
                                    <td style="width:100px;">订单状态</td>
                                    <td style="width:55px;">操作</td>
                                </tr>
                                </thead>
                                <tbody v-if="!isLoading">
                                <tr v-for="(item,i) in List" @mousemove="showRemark(i)" @mouseout="remarkIndex=''">
                                    <td>
                                        <span class="shi" v-if="item.PackageType==1">日</span>
                                        <span class="orange" v-if="item.PackageType==2">预</span>
                                        <div class="order-number">
                                            <span class="order-btn" @click="routerToDetails(item.QGOrderNo)"><a
                                                    href="javascript:void(0)" class="name">{{item.QGOrderNo}}</a></span><br>
                                            <span style="color: #999">{{item.CreateDate|dateToYMDline}} {{item.CreateDate|dateHMS}}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <a class="name" href="javascript:void(0)" :title="item.ProductName" style="width: 220px;">{{item.ProductName}}</a>
                                        <span style="width: 200px;" class="room-type" :title="item.SKUName">{{item.SKUName}}</span>
                                    </td>
                                    <td>{{item.Count}}</td>
                                    <td><span v-if="item.PackageType==1">{{item.CheckIn|dateToYMDline}}</span><span v-if="item.PackageType==2">{{item.EndActiveDate|dateToYMDline}}</span></td>
                                    <td>
                                        <span class="price">{{item.Currency}}{{item.TotalAmount.toFixed(2)}}</span><br>
                                        <span v-if="item.PayStatu == 0&&item.NeedPay" @click="routerBookComfirm(item)"><a class="" href="javascript:void(0)">去支付</a></span>
                                        <span v-else>{{item.PayStatuName}}</span>
                                    </td>

                                    <td class="status">
                                        <span v-if="item.PackageType==1">
                                            <span v-if="item.Status == 10&&item.NeedPay">待付款</span>
                                            <span v-if="item.Status == 10&&!item.NeedPay">待确认</span>
                                            <span v-if="item.Status == 11&&item.NeedPay">待付款</span>
                                            <span v-if="item.Status == 11&&!item.NeedPay">待确认</span>
                                            <span v-if="item.Status == 20">已确认</span>
                                            <span v-if="item.Status == 40">已使用</span>
                                            <span v-if="item.Status == 50">已取消</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="item.Status == 10&&item.NeedPay">待付款</span>
                                            <span v-if="item.Status == 10&&!item.NeedPay">待预约</span>
                                            <span v-if="item.Status == 11">预约中</span>
                                            <span v-if="item.Status == 12">部分预约</span>
                                            <span v-if="item.Status == 20">已预约</span>
                                            <span v-if="item.Status == 40">已使用</span>
                                            <span v-if="item.Status == 50">已取消</span>
                                        </span>
                                        <br>
                                        <span v-if="item.CanCancel" @click="cancelOrder(item)"><a href="javascript:void(0)">去取消</a></span>
                                    </td>
                                    
                                    <td>
                                        <a href="javascript:void(0)" @click="routerToDetails(item.QGOrderNo)">详情</a>
                                    </td>
                                    
                                    
                                </tr>
                                </tbody>
                            </table>
                            <div class="table-loading" v-if="isLoading">
                                <Loading :isLoading="isLoading"></Loading>
                            </div>
                            <div class="table-no-more" style="width: 100%" v-if="!isLoading&&total ==0">
                                暂无数据...
                            </div>
                        </div>
                        <Paginate :pageIndex="Page" :pageTotal="Math.ceil(total/PageSize)" @select="pageSelect" v-if="total>10"></Paginate>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false" @ok="cancel"></Modal>
    </div>
</template>

<script>
    import DatePicker from './../../common/cmpnt/datePicker/datePicker.vue'//日期
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Menu from './../../common/cmpnt/menu/Menu'
    import Paginate from './../../common/cmpnt/paginate/paginate.vue'//分页
    import Modal from './../../common/cmpnt/Modal/modal'


    export default {
        name: "packageOrderList",
        components: {
            DatePicker,
            Loading,
            Menu,
            Paginate,
            Modal
        },
        data: function () {
            return {
                List: [],
                total: 0,
                Page: 1,
                PageSize: 10,
                isLoading: false,
                remarkIndex:'',
                modal:{
                    show:false,
                    config:{}
                },
            }
        },
        mounted() {
            var that = this
            that.initData();
            document.title='度假订单---订房易';
            that.$nextTick(() => {
                if(localStorage.getItem('lang')=='t'){
                    that.$zh_tran(localStorage.getItem('lang'))
                }      
            })

        },
        methods: {
            cancelOrder(item){
                if(!item.Token){
                    return
                }
                var that = this;
                var params = {
                    Token:item.Token
                }
                that.cancelToken = params
                that.modal={
                    show:true,
                    content:'确定要取消订单号:"' + item.QGOrderNo + '"的订单吗?',
                    yes:'确定',
                    no:'取消',
                    isComfirm:true
                }
            },
            cancel(){
                var that = this;
                that.modal.show = false;
                that.isLoading = true;
                that.postRequest({
                    url: that.Api.cancelPackageOrder,
                    params: that.cancelToken
                }).then(res => {
                    if (res.IsSuccess) {
                        that.initData()
                    } else {
                        that.error({title: '提示', content: res.Msg || '取消失败'});
                    }
                });
            },

            routerToDetails(id){
                const {href} = this.$router.resolve({
                    name: 'packageOrderDetails',
                    params: { orderNO: id }
                })
                window.open(href+'packageOrderDetails/'+id, '_blank')
            },
            showRemark(i){
              this.remarkIndex = i;
            },
            // 选择页数
            pageSelect(val){
                this.total=0;
                this.List=[];
                this.Page=val;
                this.initData();
            },
            routerBookComfirm(item){
                var that = this;
                var time = Date.parse(new Date())
                that.$router.push('/packageBookComfirm?OrderNO='+item.QGOrderNo+'&time='+time)
            },

            initData() {
                var that = this;
                that.isLoading = true;
                var params = {
                    Page:that.Page,
                    PageSize:that.PageSize
                }
                that.postRequest({
                    url: that.Api.getPackageOrderList,
                    params: params
                }).then(res => {
                    this.isLoading = false;
                    if (res && res.IsSuccess) {
                        that.total = res.Total;
                        that.List = res.Result;
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }        
                        })
                    } else {

                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/package/orderList.vue